import {useState,useEffect,useRef}from 'react'
import { Modal,App,Form,Input,} from 'antd';
import GetUserDept from '../../cpn/GetUserDept';
import { EditOutlined } from '@ant-design/icons';
import { useBnsXiangMuUpdateQuery, useBnsXiangMuUpdateSaveMutation } from '../../store/BnsKeJiApi';
import MyEditor from '../../cpn/MyEditor';
function ProjectEdit(props) {
    const {message} = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bxm_content:''
    }); 
    const {data,isSuccess} = useBnsXiangMuUpdateQuery({bxm_id:props.bxm_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bxm_content:data.Result.bxm_content,
                    bxm_dept_id:data.Result.bxm_dept_id,
                    bxm_name:data.Result.bxm_name,
                })
                setInfo(prevState=>({...prevState,         
                    bxm_content:data.Result.bxm_content,
                    bxm_dept_id:data.Result.bxm_dept_id,        
                    bxm_dept_name:data.Result.bxm_dept_name,        
                    bxm_name:data.Result.bxm_name,        
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsXiangMuUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined/> 修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改项目'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "bxm_content" : info.bxm_content,
                        "bxm_dept_id" : info.bxm_dept_id,
                        "bxm_dept_name" : info.bxm_dept_name,
                        "bxm_name" : info.bxm_name,
                        "bxm_e_id" : props.e_id,
                        "bxm_id" : props.bxm_id,
                        "bxm_uid" : props.eu_id,
                        "bxm_uname" : props.eu_name,                           
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                   <GetUserDept 
                        label='部门'
                        required
                        wrapperCol={{span:10}} 
                        getUserDept={(e,f) => {
                            setInfo(prevState=>({...prevState,bxm_dept_id:e,bxm_dept_name:f}))
                        }}
                        name='bxm_dept_id'
                    />
                     <Form.Item 
                        name="bxm_name" 
                        label='项目名称' 
                        wrapperCol={{span:20}} 
                        required
                    >
                        <Input 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bxm_name:e.target.value}))}}
                        />
                    </Form.Item> 
                    <Form.Item 
                        name="bxm_content" 
                        label='项目说明' 
                        wrapperCol={{span:21}}                            
                    >
                        <MyEditor  onChange={(e) => {setInfo(prevState=>({...prevState,bxm_content:e}))}}/>
                    </Form.Item>  
                </Form>
            </Modal>
        </>
    )
}

export default ProjectEdit